import React, { FC, useEffect } from 'react';
import { SolicitacaoDetalhada } from "model/solicitacao/SolicitacaoDetalhada";
import { useDispatch, useSelector } from 'react-redux';
import { LoadingTexto, Texto } from '../Tipografia/Texto';
import { AvaliacaoSelector } from 'store/Avaliacao/Avaliacao.selector';
import { AvaliacaoAction } from 'store/Avaliacao/Avaliacao.action';
import { useCampoFormularioProps } from 'service/restricao/useCampoFormularioProps/useCampoFormularioProps';
import { AlertaInline } from '../AlertaInline/AlertaInline';


export interface AvaliacaoInfoProps {
  name: string;
  solicitacao: SolicitacaoDetalhada;
}

export const AvaliacaoInfo: FC<AvaliacaoInfoProps> = ({solicitacao, name}) => {
  const dispatch = useDispatch();
  const restricoesProps = useCampoFormularioProps(name);

  const ocioso = useSelector(AvaliacaoSelector.lista.isOcioso);
  const carregando = useSelector(AvaliacaoSelector.lista.isCarregando);
  const hasErros = useSelector(AvaliacaoSelector.lista.hasErros);
  const avaliacoes = useSelector(AvaliacaoSelector.lista.elementos);

  useEffect(() => {
    if (ocioso && solicitacao.id !== 0) {
      dispatch(AvaliacaoAction.lista.carregarAvaliacoes(solicitacao.id));
    }
  }, [dispatch, ocioso, solicitacao.id]);

  if (restricoesProps.hidden)
    return <></>
  
  if (carregando || ocioso) {
    return <LoadingTexto width={100} />
  }
  if (hasErros) {
    return <>
      <LoadingTexto width={100} tipo="span" />
      <AlertaInline mensagem="Não foi possível obter as avaliações, tente novamente mais tarde." />
    </>
  }

  if (avaliacoes.length === 0) {
    return <Texto>Nenhuma avaliação realizada</Texto>
  }

  const notaExibicao = avaliacoes.reduce((prevVal, elem) => prevVal + elem.nota, 0)/avaliacoes.length;

  return (
    <Texto>{avaliacoes.length>1 ? `${notaExibicao} (média)` : `${notaExibicao}`}</Texto>
  )
}
